// extracted by mini-css-extract-plugin
export default {"btBlue":"ViewMedicalHistory_btBlue__KlVTJ","btGray":"ViewMedicalHistory_btGray__Boszu"};